import { APIClient } from '@frontend/api-utils';
import { ModuleSpecification } from '@frontend/module/types';

export class ModuleSpecificationClient extends APIClient {
    public static readonly endpoint = '/module-api/v1';

    public static async fetchModuleSpecification(accountId: string, spotId: string, moduleId: string): Promise<ModuleSpecification> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/specification`);
        return await this.handleResponse<ModuleSpecification>(response);
    }
}
